<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M5 12c-1.111 0-2.056-.389-2.833-1.167C1.389 10.056 1 9.111 1 8c0-1.111.389-2.056 1.167-2.833C2.944 4.389 3.889 4 5 4h6.667c1.11 0 2.055.389 2.833 1.167.778.777 1.167 1.722 1.167 2.833 0 1.111-.39 2.056-1.167 2.833-.778.778-1.722 1.167-2.833 1.167H5Zm0-1.333h6.667c.733 0 1.36-.261 1.883-.784.522-.522.783-1.15.783-1.883 0-.733-.26-1.361-.783-1.883a2.568 2.568 0 0 0-1.883-.784H5c-.733 0-1.361.261-1.883.784A2.568 2.568 0 0 0 2.333 8c0 .733.261 1.361.784 1.883.522.523 1.15.784 1.883.784ZM11.667 10c.555 0 1.027-.194 1.416-.583.39-.39.584-.861.584-1.417s-.195-1.028-.584-1.417A1.929 1.929 0 0 0 11.667 6c-.556 0-1.028.194-1.417.583A1.929 1.929 0 0 0 9.667 8c0 .556.194 1.028.583 1.417.389.389.861.583 1.417.583Z"
        />
    </svg>
</template>

<script setup lang="ts">
type ToggleOnIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<ToggleOnIconProps>();
</script>
